import React, { useContext, useMemo, useState } from 'react';

interface MediaContextType {
  mediaId?: string;
  setMediaId: React.Dispatch<React.SetStateAction<string | undefined>>;
}

const MediaIdContext = React.createContext<MediaContextType | undefined>(
  undefined
);

const MediaIdProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, setState] = useState<string | undefined>();
  const contextValue = useMemo(
    () => ({ mediaId: state, setMediaId: setState }),
    [state, setState]
  );

  return (
    <MediaIdContext.Provider value={contextValue}>
      {children}
    </MediaIdContext.Provider>
  );
};

function useMediaIdContext() {
  const context = useContext(MediaIdContext);
  if (context === undefined) {
    throw new Error(
      '`useMediaIdContext` must be used within a `MediaIdContext.Provider`'
    );
  }
  return context;
}

export { useMediaIdContext, MediaIdProvider };
